import { lazy } from 'react';

/**
 * The DXF renderer's lazy boundary — the single reason three.js is not in the app's
 * initial bundle.
 *
 * `three` is reachable from the app graph *only* through this dynamic import. A
 * static import of `@frontend/dxf-renderer` (or of `three` itself) from anywhere in
 * `src/` would put the whole engine in an initial chunk loaded on every page view,
 * which is what happened while the prototype rendered its canvas inline. Lint
 * enforces it; this file is the sole exemption.
 *
 * The boundary sits around the canvas rather than around the viewer so that the
 * shell — handle, pan/zoom, text layer, layer panel, toolbar — stays eager and
 * three-free, and the drawing's text is placed and interactive before the engine
 * chunk resolves.
 *
 * Mirrors how the CAD viewer loads `@frontend/partviewer` (`cadViewer/components/PartViewer.js`),
 * but resolves the named export rather than a default one, so the renderer package
 * needs no default export to satisfy `lazy`'s module shape.
 */
export const DxfSceneCanvas = lazy(async () => ({
  default: (
    await import(
      /* webpackChunkName: 'dxf_renderer' */ '@frontend/dxf-renderer'
    )
  ).DxfSceneCanvas,
}));
